import { isLogicalFilter } from '@/sections/insights/queryBuilder/utils/filterTypeGuards';
import type { Operator, QueryFilter } from '@/types';

/**
 * Normalize filters to have one level of logical nesting
 **/
export function normalizeFilters(
  filters: QueryFilter[] | undefined
): QueryFilter[] {
  if (!filters) {
    return [
      {
        field: '',
        operator: 'AND' as Operator,
        value: [],
      },
    ];
  }

  // All outermost filters are logical - already normalized
  if (filters.every(isLogicalFilter)) {
    return filters;
  }

  const logicalFilters: QueryFilter[] = [];
  const leafFilters: QueryFilter[] = [];

  for (const filter of filters) {
    if (isLogicalFilter(filter)) {
      logicalFilters.push(filter);
    } else {
      leafFilters.push(filter);
    }
  }

  const normalized = [
    ...logicalFilters,
    {
      field: '',
      operator: 'AND' as Operator,
      value: leafFilters,
    },
  ];

  // At least one leaf filter - wrap all in explicit AND
  return normalized;
}
